import { useContext, useEffect } from "react";
import Product from "../../../Components/website/Product/Product";
import axios from "axios";
import { baseURL, LatestSALE } from "../../../Api/Api";
import { Container } from "react-bootstrap";
import { requstData } from "../../../context/RequstContext";
import { motion } from "motion/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesLeft, faAnglesRight } from "@fortawesome/free-solid-svg-icons";
import ProductsShow from "../../../Components/website/Products/ProductsShow";
import Cookie from "cookie-universal";
export default function LatestSaleProduct(){
    // context data for latestSale
    const reqData=useContext(requstData);
    //cookie
     const cookie=Cookie();
     
    useEffect(()=>{
        if(reqData.latestSale.length===0)
        try{
            axios.get(`${baseURL}/${LatestSALE}`)
            .then((data)=> reqData.setlatestSale(data.data));
        }
        catch(err){
          console.log(err);
        }
    },[]);
    //Mapping
    const productShow=reqData.latestSale.map((pro)=>
    <Product title={pro.title} id={pro.id} 
     img={pro.images.length>0?pro.images[0].image:""}
     description={pro.description}
      discount={pro.discount} price={pro.price}
      rating={pro.rating}/>
    )
  
    return(
        reqData.latestSale.length>0&&
         <motion.div className="d-flex position-relative align-items-start justify-content-center mb-5 w-100" 
               style={{ marginTop: '-240px',backgroundColor:'rgb(229 224 224 / 14%)'}}
                 initial={{  opacity: 0 }}
                 animate={{opacity:1}}
                 transition={{ duration: 1 }}
                 viewport={{once:true}}>
         <ProductsShow data={productShow}  title="Latest Sale Products"/>
         </motion.div>
    )
}